
import { Injectable } from "@angular/core";
import { ModelBaseService } from './base/modelBase.service';
import { BaseService } from "./base/base.service";
import { IActiveSector } from "../models/active-sector";
import { ICandidate } from "../models/candidate";
import { Observable, catchError, switchMap, tap, throwError } from "rxjs";
import { LocalStorageService } from "./base/localStorage.service";



@Injectable({
  providedIn: 'root'
})

export class CandidateService extends ModelBaseService<ICandidate> {

  constructor(public baseService: BaseService, private localStorageService: LocalStorageService
  ) {
    super(`candidates`, baseService);
  }

  getCurrentCandidate(): Observable<any> {
      return  this.baseService.getUrl('candidates/current-candidates');

  }


  getCandidateFormations(): Observable<any> {
    return this.localStorageService.getCurrentUser().pipe(
      switchMap((result: any) => {
        if (result && result._id) {
          return this.baseService.getAll(`candidates/formations/${result._id}`);
        } else {
          throw new Error('User not found or missing ID');
        }
      }),
      catchError(error => {
        // Gérer les erreurs ici
        return throwError(error);
      })
    );
  }

  updateCandidateProfile(data: any): Observable<any> {
    return this.localStorageService.getCurrentUser().pipe(
      switchMap((result: any) => {
        if (result && result._id) {
          return this.baseService.putMultipart('candidates/profile', result._id, data).pipe(
            tap(updatedProfile => {
              // Mettre à jour le profil utilisateur dans le stockage local
              this.localStorageService.removeCurrentUser();
              this.localStorageService.saveUser(updatedProfile.data);
            }));
            
        } else {
          throw new Error('User not found or missing ID');
        }
      }),
      catchError(error => {
        // Gérer les erreurs ici
        return throwError(error);
      })
    );
  }

  changePassword(data: any): Observable<any> {
    return this.localStorageService.getCurrentUser().pipe(
      switchMap((result: any) => {
        if (result && result._id) {
          return this.baseService.put('candidates/profile/update-password', result._id, data);
        } else {
          throw new Error('User not found or missing ID');
        }
      }),
      catchError(error => {
        // Gérer les erreurs ici
        return throwError(error);
      })
    );
  }

  getDashboard(): Observable<any> {
    
    return this.baseService.getUrl('candidates/dashboard');
        
  }




}
